<template>
  <div>
    <div class='print-container' v-if='!isLoading'>
      <div class='text-center mb-5'>
        <h1 class='display-1'>{{ deposit.account_obj.division_obj.company_name }}</h1>
      </div>
      <table width='100%'>
        <tr>
          <td width='50%' valign='top'>
            <span class='headline'>Deposit</span><br>
            <span class='title'>{{ deposit.date | longDate  }}</span>
          </td>
          <td width='50%'>
            <table class='wc-data-table' style='float: right'>
              <tr>
                <td>Account Name</td>
                <td class='text-right'>{{ deposit.account_obj.name }}</td>
              </tr>
              <tr>
                <td>Account Number</td>
                <td class='text-right'>{{ deposit.account_obj.number }}</td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
      <table width='100%' class='wc-data-table'>
        <thead>
          <tr class='overline'>
            <th class='text-left'>Payment date</th>
            <th>Invoice</th>
            <th>Payor</th>
            <th width='150'>Pmt Method</th>
            <th class='text-right' width='100'>Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for='(p, index) in payments' :key='index'>
            <td>{{ p.date | shortDate }}</td>
            <td class='text-center'>{{ p.invoice_obj_number }}</td>
            <td class='text-center'>{{ p.invoice_bill_to }}</td>
            <td class='text-center'>{{ p.payment_method_display }}</td>
            <td class='text-right'>{{ p.amount | dec }}</td>
          </tr>
        </tbody>
      </table>
      <br>
      <table class='wc-data-table subtitle-2' style="float: right">
        <tr>
          <td class='text-right' width='150'>Number of items:</td>
          <td class='text-right font-weight-bold' width='100'>{{ payments.length }}</td>
        </tr>
        <tr>
          <td class='text-right'>Deposit Total:</td>
          <td class='text-right font-weight-bold'>{{ total | decMoney }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import depositsAPI from '@/api/accounting';
import _ from 'lodash';

export default {
  name: 'deposit-printout',
  data: () => ({
    isLoading: true,
    deposit: {},
    payments: []
  }),
  computed: {
    total () {
      return _.sumBy(this.payments, 'amount');
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true;
      this.deposit = await depositsAPI.getDeposit(this.$route.params.id);
      this.payments = await depositsAPI.getPaymentsForDeposit(this.$route.params.id);
      this.isLoading = false;
    }
  }
}
</script>
